import React from 'react';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { BackButton } from '../../../../Components/Utils/Buttons';
import CustomerQuotesApprovalLimit from './CustomerQuotesApprovalLimit';
import POLimit from './POLimit';

function MainApprovalLimit() {
  return (
    <div className='w-full h-full p-2 lg:px-4'>
      <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "Approval Limit"
            }
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll shadow-sm border border-gray-100 divide-y divide-gray-100">
        <div className="p-4">
          <CustomerQuotesApprovalLimit />
        </div>
        <div className="p-4">
          <POLimit />
        </div>
      </div>
    </div>
  );
}

export default MainApprovalLimit;
